import Device from 'Faster/model/Device';
import Session from 'Faster/model/Session';
import FasterRequest from 'Faster/network/FasterRequest';
import ServerDate from 'Faster/model/ServerDate';

class CreateSessionRequest implements FasterRequest {
  public readonly method: string = FasterRequest.METHOD_POST;
  private device: Device;
  private session: Session;
  private ntpDate: Date;

  public constructor(device: Device, session: Session) {
    this.device = device;
    this.session = session;
    this.ntpDate = ServerDate.now();
  }

  public body(): object {
    return {
      sessionId: this.session.id,
      deviceId: this.device.id,
      userId: this.session.userId,
      geoPoint: this.session.geoPoint,
      systemVersion: this.device.systemVersion,
      appVersion: this.device.appVersion,
      sdkVersion: this.device.sdkVersion,
      pushToken: this.device.pushToken,
      cloudId: this.device.cloudId,
      carrierId: this.device.carrierId,
      timezone: this.device.timezone,
      language: this.device.language,
      deviceProperties: this.device.properties,
      sessionProperties: this.session.properties,
      createdInBackground: this.session.createdInBackground,
      localTimestamp: this.session.startedAt,
      ntpLocalTimestamp: this.ntpDate,
    };
  }

  public headers(): object {
    return {
      'Content-Type': 'application/json',
    };
  }

  public endpoint = (): string => '/v1/session';

  public query = (): string => '';
}

export default CreateSessionRequest;
